import {injectable, decorate} from 'inversify';
import {getSiteInfo} from '../..';
import {ISiteInfoProvider} from './ISiteInfoProvider';

export class SiteInfoProvider implements ISiteInfoProvider {
  obtain() {
    return getSiteInfo();
  }
}

decorate(injectable(), SiteInfoProvider);
